import background from "../images/background.svg";
import { userService } from "../services/user.service";
import { useContext, useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import  AppRoutes  from "../AppRoutes";
import { doLogout, doRefreshUser, useAuthDispatch, useAuthState } from "../context/AuthContext";


const Bind = (props) => {
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState("");
  const [licenceBound, setLicenceBound] = useState(false);
  const { user } = useAuthState();
  const dispatch = useAuthDispatch();
  const navigate = useNavigate();
  const handleChange = (e) =>
    setInputs((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

  const handleBindClick = async (e) => {
    e.preventDefault();
    setError("");
    const licenceKey = inputs.licence;
    const result = await userService.bindKeyToUser(licenceKey);
    if (result.status !== 200) {
      setError(result.data.message);
    } else {
      await doRefreshUser(dispatch);
    }
  };

  const handleSignOut = async () => {
    await doLogout(dispatch);
  };

  useEffect(() => {

  }, []);

  /**
   * Navigate to dashboard if licence exists
   */
  if (user.licence) return <Navigate to="/dashboard"/>

  return (
    <>
      <div className="relative flex min-h-screen flex-col justify-center overflow-x-hidden">
        <img src={background} className="absolute h-full w-full object-cover" />
        <div className="relative mx-auto max-w-lg !rounded-xl border border-gray-200 dark:border-gray-700 dark:bg-gray-700">
          <div className="p-5">
            <h3 className="text-left font-sans text-3xl font-bold text-black !text-opacity-100 dark:text-white">
              No Licence - Bind for Access
            </h3>
            <div className="mt-3 text-left font-sans text-black !text-opacity-50 dark:text-white">
              Enter your licence key below to bind your key your account. Once
              you have bound your licence you will be re-directed to your user
              dashboard.
              <br />
              <br />
              Check your emails if you can't find your key.
            </div>
            <form
              action="#"
              autoComplete="off"
              className="mt-5 flex w-full flex-col"
            >
              <div className="flex flex-row">
                <input
                  onChange={handleChange}
                  name="licence"
                  id="licence"
                  type="text"
                  autoComplete="off"
                  spellCheck="false"
                  autoCorrect="off"
                  className="dark:!border-gray-850 relative mr-2 h-9 w-full flex-1 rounded !border-gray-200 bg-opacity-0 py-0 px-3 text-sm text-gray-800 placeholder-gray-300 !ring-blue-400 !ring-opacity-40 focus-within:z-10 focus:!border-blue-300 focus:!outline-none focus:!ring dark:bg-opacity-20 dark:placeholder-gray-500 dark:focus:!border-blue-400"
                  placeholder="XXXX-XXXX-XXXX-XXXX-XXXX"
                />
                <button
                  onClick={handleBindClick}
                  type="submit"
                  className="dark:text-gray-150 dark:border-gray-550 dark:after:via-gray-550 relative box-border inline-flex h-9 min-w-min flex-initial select-none appearance-none items-center justify-center whitespace-nowrap rounded border border-gray-300 bg-white !px-4 px-3 text-center align-middle text-gray-800 shadow-sm outline-none transition after:via-gray-100 hover:bg-white hover:shadow-md focus:bg-white focus:shadow-md focus:outline-none focus:outline-none active:bg-gray-200 active:!shadow-none dark:bg-gray-600 dark:hover:bg-gray-700 dark:focus:bg-gray-700 dark:active:bg-gray-800"
                >
                  Bind
                </button>
              </div>
              <div className="mt-5">
                <a
                  href="#"
                  onClick={handleSignOut}
                  className="hover:text-gray-300 bg-primary-700 hover:bg-primary-800 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 inline-flex items-center rounded-lg py-2 text-center text-sm font-medium text-white focus:ring-4"
                >
                  Sign Out
                </a>
              </div>
            </form>
          </div>

          {error && (
            <div
              className="relative m-2 rounded border border-red-400 bg-red-100 px-4 py-3 text-red-700"
              role="alert"
            >
              <strong className="font-bold">Error Binding Licence</strong>
              <span className="block">{error}</span>
              <span className="absolute top-0 bottom-0 right-0 px-4 py-3"></span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Bind;
